import 'raty-js';

// Path is hardcoded to production cloudfront due to
// not being able to read full asset path at runtime
// in JS — if you ever change this, it also needs to be
// change in feedback.js
const initializeRaty = function () { // Ratings
  $('.raty-star.read-only').each((index, element) => {
    const opts = {
      path: '',
      starHalf: 'https://images.reverb.com/image/upload/v1450205868/feedback_half-star_ovwhoi.png',
      starOn: 'https://images.reverb.com/image/upload/v1433195155/star-on-3_kfbbby.png',
      starOff: 'https://images.reverb.com/image/upload/v1433195155/star-off-3_vyhsla.png',
      readOnly: true,
      halfShow: false,
      space: false,
      score: $(element).attr('rel'),
    };

    $(element).raty(opts);
  });
};

$(initializeRaty);
$(document).on('ajaxComplete', initializeRaty);



// WEBPACK FOOTER //
// ./javascripts/components/legacy/raty.js